$ = require 'jquery'
React = require 'react'
ReactDOM = require '@trello/react-dom-wrapper'
Auth = require 'app/scripts/db/auth'
Backbone = require 'app/scripts/lib/backbone'
EventsMixin = require 'app/scripts/lib/events-mixin'
Hearsay = require 'hearsay'
{ currentModelManager } = require './currentModelManager'
{ Key, registerShortcut, Scope } = require '@trello/keybindings'
PostRender = require 'app/scripts/views/lib/post-render'
Promise = require 'bluebird'
{ Storage } = require '@trello/storage'
logError = require 'app/scripts/debug/log-error'
Util = require 'app/scripts/lib/util'
_ = require 'underscore'
{ mixin } = require 'app/scripts/lib/mixin_DO_NOT_USE'
l = require 'app/scripts/lib/localize'
{ featureFlagClient } = require '@trello/feature-flag-client'
assert = require 'app/scripts/lib/assert'
f = require 'effing'
ApiError = require 'app/scripts/network/api-error'
{ ErrorViews } = require 'app/common/data/error-views'
getQueryParamByKey = require 'app/scripts/lib/util/url/get-query-param-by-key'
getExperiment = require 'app/scripts/lib/experiments/simple-test'
{ navigateFactory } = require 'app/scripts/controller/navigate'
{ track, trackPageview } = require '@trello/analytics'
{ client, clientVersion } = require '@trello/config'
{ defaultRouter, RouteNames } = require 'app/common/router'

memberIdStorageKey = 'idMe'

{ defaultStore } = require 'app/gamma/src/defaultStore'
{ navigateStart, navigateStop } = require 'app/gamma/src/modules/state/ui/navigating'
{ closePopovers } = require 'app/gamma/src/modules/state/ui/popovers'
{ addBoardToRecent } = require 'app/gamma/src/modules/state/ui/boards-menu'
{ removeOverlay } = require 'app/gamma/src/modules/state/ui/overlay'
{ clearSearchQuery } = require 'app/gamma/src/modules/state/models/search'
{ toggleBoardsMenu } = require 'app/gamma/src/modules/state/ui/boards-menu'

headerLoad = (methodName, eventName) ->
  # Dependency required at call site to avoid import cycles, do not lift to top of module
  ModelLoader = require 'app/scripts/db/model-loader'

  actualLoad = if Auth.isLoggedIn()
    ModelLoader.for('header', methodName)
  else
    Promise.resolve(null)

  actualLoad.then ->
    ModelLoader.triggerWaits(eventName)
  .catch ApiError, (err) ->
    logError new Error("headerLoad ApiError, err = #{err}, err.constructor.name = #{err.constructor.name}")
    throw err
  .catch ApiError.Unauthenticated, (err) ->
    # We've previously tried logging people out when they get an unauthorized error,
    # while loading the header, under the assumption that they've somehow got a bad cookie.
    # Unfortunately we've had some firefox users reporting that this is logging them out
    # when it shouldn't be
    console.log("Error trying to load header")
  .done()

mixin EventsMixin, class Controller extends Backbone.Router
  initialize: ->
    @_savedTitle = ""
    @currentModel = currentModelManager.currentModel

  getQueryParamByKey: getQueryParamByKey

  start: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    JoinOnConfirm = require 'app/scripts/lib/join-on-confirm'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    rpc = require 'app/scripts/network/rpc'

    rpc.on 'subscription_unauthorized', (modelType, idModel) =>
      shouldDisplayError = switch modelType
        when 'Board' then @onBoardView(idModel)
        when 'Organization' then @onOrganizationView(idModel)
        else false

      if shouldDisplayError
        errorType = if modelType == 'Board'
            ErrorViews.BOARD_NOT_FOUND
          else
            ErrorViews.NOT_FOUND

        @displayErrorPage({ errorType })

    headerLoad 'loadHeaderData', 'headerData'
    setTimeout f(headerLoad, 'loadBoardsMenuData', 'boardsData'), 500

    if Auth.isLoggedIn()
      ModelLoader.await('headerData')
      .then ->
        # set idMe in localStorage
        Storage.set(memberIdStorageKey, Auth.myId())
        # LaunchDarkly - Once we have the header data
        # we can send a more informative user object to LD
        featureFlagClient.refineUserData({
          channel: Auth.me().get('channels')?.active
          idOrgs: Auth.me()?.get('idOrganizations') ? []
          emailDomain: Auth.me()?.get('email')?.split('@')[1] ? ''
          idEnterprises: Auth.me()?.get('enterprises')?.map((enterprise) => enterprise.id) ? []
          orgs: ['[Redacted]']
          clientVersion: clientVersion
          head: client.head
          version: client.version
        })
      .done()

    onShortcut = =>
      if @onAnyBoardView()
        @navigate('shortcuts/overlay')
        @shortcutsViewOverlay()
      else
        @navigate '/shortcuts', trigger: true
      track 'Keyboard Shortcuts', 'Shortcuts page'

    registerShortcut(onShortcut, { scope: Scope.Global, key: Key.QuestionMark })

    JoinOnConfirm.autoJoin()
    .then (didJoin) ->
      if didJoin
        # We can't trust that the stuff that we quickloaded is
        # going to be accurate, or that we'll catch the updates
        # when we subscribe, so just dump it to be safe
        QuickLoad.clear()
    .return()

  viewType: 'none'

  topLevelView: (viewType, model, options) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ApplicationView = require 'app/scripts/views/application-view'
    @applicationView ?= new ApplicationView()
    options ?= {}
    options.modelCache ?= @getCurrentModelCache()
    @applicationView.subview(viewType, model, options)

  existingTopLevelView: (viewType, model) ->
    @applicationView.existingSubview(viewType, model)

  existingTopLevelViewOrUndefined: (viewType, model) ->
    @applicationView?.existingSubviewOrUndefined(viewType, model)

  title: (title) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    FavIcon = require 'app/scripts/lib/favicon'

    if title?
      @_savedTitle = title

    unreadNotifications = Auth.isLoggedIn() && Auth.me().unreadNotifications()
    fullTitle = ""
    if @_savedTitle?.length > 0
      fullTitle += "#{ @_savedTitle } | "
    fullTitle += "Trello"

    # If someone happens to be using fluid, update their dockBadge
    # http://fluidapp.com/developer/
    window.fluid?.dockBadge = (if unreadNotifications then unreadNotifications else null)

    document.title = fullTitle

  setLocation: ({ title, location, options }) ->
    if title?
      @title(title)

    if location
      if /^#/.test(location)
        location = location.substr(1)

      @navigate(location, options)
      @location = location
    return

  showingCalendar: (boardView) ->
    boardView?.$('.calendar-wrapper').length > 0

  showingMap: (boardView) ->
    boardView?.$('.map-wrapper').length > 0

  setBoardLocation: (idBoard, section = '', extra = [], options) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    name = ModelCache.get('Board', idBoard).get('name')
    @setLocation(
      title: name
      location: @getBoardUrl(idBoard, section, extra)
      options: options
    )
    return

  saveMemberBoardProfileLocation: (member, idBoard) ->
    @setLocation
      title: member.get('fullName')
      location: @getMemberBoardProfileUrl(member.get('username'), idBoard)

  isOnSearchPage: -> @currentPage == 'search'

  onAnyOrganizationView: currentModelManager.onAnyOrganizationView
  onOrganizationView: currentModelManager.onOrganizationView
  onAnyBoardView: currentModelManager.onAnyBoardView
  onBoardView: currentModelManager.onBoardView
  getCurrentBoard: currentModelManager.getCurrentBoard

  # This is gross, but slightly better than having a global 'boardView' variable
  getCurrentBoardView: ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    BoardView = require 'app/scripts/views/board/board-view'
    @existingTopLevelViewOrUndefined(BoardView, @getCurrentBoard())

  getCurrentModelCache: -> @currentModelCache

  saveBoardsView: ->
    if @savedBoardViewInformation? || !@onAnyBoardView()
      return

    @savedBoardViewInformation =
      idBoard: @currentModel.get().id
      path: /// /b/[^/]*/(.*) ///.exec(@location)[1]
    return

  loadBoardsView: ->
    if !@savedBoardViewInformation
      return

    { idBoard, path } = @savedBoardViewInformation

    @boardView idBoard, path

    delete @savedBoardViewInformation

  clearPreviousView: (options) ->
    options ?= {}
    options.shallow ?= false
    options.isNextViewReact ?= false

    { shallow, isNextViewReact } = options

    # Dependency required at call site to avoid import cycles, do not lift to top of module
    AttachmentViewer = require 'app/scripts/views/internal/attachment-viewer'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    Dialog = require 'app/scripts/views/lib/dialog'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    PluginModal = require 'app/scripts/views/lib/plugin-modal'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    PopOver = require 'app/scripts/views/lib/pop-over'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    SearchState = require 'app/scripts/view-models/search-state'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    Board = require 'app/scripts/models/board'

    # shallow = true is for singlespa page transitions
    if shallow
      SearchState.setQuery("")
      PopOver.hide()
      PluginModal.close()
      if Dialog.isVisible
        Dialog.hide(true)

      return

    defaultStore.dispatch(toggleBoardsMenu(false))
    defaultStore.dispatch(closePopovers())
    defaultStore.dispatch(removeOverlay())
    defaultStore.dispatch(clearSearchQuery())

    ReactDOM.unmountComponentAtNode(document.getElementById('content'))

    SearchState.setQuery("")
    @applicationView?.remove()
    delete @applicationView
    PopOver.hide()
    PluginModal.close()
    if Dialog.isVisible
      Dialog.hide(true)
    if !isNextViewReact
      ReactDOM.unmountComponentAtNode(document.getElementById('content'))
      $('#content').html('')
    $('body')
    .scrollTop('0')
    $('#trello-root')
    .removeClass('body-single-column body-tabbed-page body-search-page
      body-board-view body-custom-board-background
      body-custom-board-background-tiled body-light-board-background
      body-dark-board-background body-ambiguous-board-background
      body-default-header body-hide-header')
    .css
      'background-image': ''
      'background-color': ''
      AttachmentViewer.clear()
    return

  # Call this *after* loading data, before displaying
  # (So the transition is instant)
  setViewType: (modelOrString) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    FavIcon = require 'app/scripts/lib/favicon'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelCache = require 'app/scripts/db/model-cache'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    SidebarState = require 'app/scripts/view-models/sidebar-state'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    Board = require 'app/scripts/models/board'
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    { isInspirationBoard } = require 'app/scripts/views/onboarding/helpers'

    if @currentModel.get() instanceof Board
      @currentModel.get().markAsViewed()

    if _.isString(modelOrString)
      @currentModelCache = ModelCache
      @currentModel.set null
    else
      @currentModelCache = modelOrString.modelCache
      @currentModel.set modelOrString
    @currentPage = modelOrString

    if @currentModel.get() instanceof Board
      board = @currentModel.get()
      @waitForId board, ->
        # [MARK AS VIEWED]
        board.markAsViewed()
        SidebarState.pushBoard(board.id)

        if !isInspirationBoard(board.id)
          $('#js-inspiration-popover-mount').remove()

        defaultStore.dispatch(addBoardToRecent(
          id: board.id
        ))

    else
      FavIcon.setBackground({ useDefault: true })
      $('#js-inspiration-popover-mount').remove()

    return

  onCardView: ->
    # Hey look! We're duplicating code. In actually the *third* place.
    # isWebClientPage has this check, it's defined in the route above,
    # and we have it here too.
    # Turns out Backbone's router gives you *no* inspection ability. It
    # doesn't return any routes that you create. The method that converts
    # routes into regular expressions is private. Even if you create a named
    # route, there's no way to retrive the Backbone route object for that.
    # So! When we stop using Backbone's router, make sure to come back and
    # fix this.
    ///^ c/ [a-zA-Z0-9]{8} (/[^/]+)? ///.test Backbone.history.fragment

  organizationById: (idOrganization) ->
    # Dependency required at call site to avoid import cycles, do not lift to top of module
    ModelLoader = require 'app/scripts/db/model-loader'
    ModelLoader.for 'top-level', 'loadOrgNameById', idOrganization
    .then (name) =>
      @organizationBoardsView(name)
    .catch ApiError, =>
      @displayErrorPage()
    .done()

  getSpinner: ->
    defaultStore.dispatch(navigateStart())
    return Promise.resolve().disposer ->
      defaultStore.dispatch(closePopovers())
      defaultStore.dispatch(navigateStop())
      return

  focusContent: ->
    # Focus the content, so it can immediately be scrolled
    # with the arrow keys.  The tabindex is necessary
    # to make the div focusable. This causes a style recalc/reflow
    # so deferring it via setTimeout
    _.defer =>
      $('#content').attr('tabindex', '-1').focus()

backboneNavigate = Backbone.History::navigate

_.extend Backbone.History.prototype,
  navigate: (path, options) ->
    navigate = navigateFactory(backboneNavigate.bind(@), @location.pathname, (fragment) => trackPageview(fragment or 'boards'))
    navigate(path, options)

{ userOrOrgRoutes } = require './user-or-org-routes'
{ catchAllRoute } = require './catchall-route'

components = [
  require './display-board'
  require './urls'
  require './header'
  require './footer'
  require './quick-boards'
  require './power-up-routes'
  require './other-routes'
  require './invitation-routes'
  require './board-routes'
  userOrOrgRoutes
  require './enterprise-routes'
  require './member-routes'
  require './organization-routes'
  catchAllRoute
]

routes = _.chain components
.map (component) ->
  _.extend Controller.prototype, component
  delete Controller.prototype.routes
  component.routes
.compact()
.flatten(true)
.value()
.reverse() # https://github.com/jashkenas/backbone/issues/1463

singleton = new Controller()
routes.forEach ([route, name]) ->
  singleton.route route, name
module.exports = singleton

# [MARK AS VIEWED]
#
# The right thing to do would be to have all this accounting-for-
# views code observe the current location of the Controller, instead
# of having the Controller know about that much. A good project
# for a future refactor.
